var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300.005 300.005",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 97.035,
    cy: 229.666,
    r: 6.406
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.179,
    cy: 229.666,
    r: 6.406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,0C67.159,0,0.002,67.162,0.002,150S67.159,300.005,150,300.005S300.003,232.841,300.003,150S232.841,0,150,0z  M202.179,251.634c-12.112,0-21.965-9.856-21.965-21.971c0-2.225,0.34-4.378,0.957-6.404h-63.126 c0.62,2.026,0.957,4.176,0.957,6.404c0,12.115-9.853,21.971-21.968,21.971s-21.968-9.856-21.968-21.971 c0-10.821,7.872-19.815,18.187-21.615L68.862,85.201l-18.819,0.124L49.94,69.763l31.64-0.21l7.656,37.883l94.413,11.319 c-0.052,0.796-0.122,1.585-0.122,2.394c0,21.413,16.763,38.941,37.851,40.261l-8.318,31.692H106.354l2.651,14.594h93.171 c12.112,0,21.971,9.853,21.971,21.965C224.147,241.778,214.291,251.634,202.179,251.634z M223.921,151.167 c-16.555,0-30.019-13.466-30.019-30.016s13.464-30.016,30.019-30.016c16.55,0,30.013,13.466,30.013,30.016 S240.468,151.167,223.921,151.167z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.702,103.906 216.14,103.906 216.14,113.803 206.24,113.803 206.24,129.365 216.14,129.365 216.14,139.257  231.702,139.257 231.702,129.365 241.594,129.365 241.594,113.803 231.702,113.803  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.823972d108b1156a52980d1b0c70281e.svg";
export { ForwardRef as ReactComponent };